import { Accordion } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import './faq.css'; // Adjust path if needed


const FAQ = () => {

    const faq = [
        {
            question: "What makes Gautam Solar panels different from other solar brands?",
            answer: "Gautam Solar combines 29+ years of manufacturing experience with advanced N-Type TOPCon and Mono PERC technology, ALMM and BIS certification, and in-house R&D — delivering higher efficiency, lower degradation rates, and consistent quality control across every module produced."
        },
        {
            question: "Is Gautam Solar an ALMM-approved manufacturer?",
            answer: "Yes, Gautam Solar is listed in the Approved List of Models and Manufacturers (ALMM) maintained by the Ministry of New and Renewable Energy (MNRE), making its modules eligible for government-sponsored and subsidy-linked solar projects in India."
        },
        {
            question: "Is Gautam Solar among India's top solar module manufacturers?",
            answer: "Yes, Gautam Solar has been ranked among India's Top 10 solar module manufacturers by JMK Research & Analytics in its RE Update FY2025 (reaffirmed in the Q1 2026 update), holding a 3.5% share of India's total module shipments. CRISIL's Bridge to India India PV Module Intelligence Brief (Q4 2024) also placed Gautam Solar among the top 10 manufacturers in a total domestic market of 12,416 MW."
        },
        {
            question: "What type of solar panels does Gautam Solar manufacture?",
            answer: "Gautam Solar manufactures advanced MonoPERC and high efficiency TOPCon solar PV modules suitable for rooftop, commercial, industrial, and large-scale solar power plants."
        },
        {
            question: "Where are Gautam Solar's manufacturing facilities located?",
            answer: "Gautam Solar has state-of-the-art module manufacturing facilities in Bhiwani (Haryana) and Haridwar (Uttarakhand) with a combined module manufacturing capacity of 5 GW, and an upcoming 5 GW solar cell manufacturing facility near Gwalior, Madhya Pradesh."
        },
        {
            question: "Are Gautam Solar panels suitable for rooftop installations?",
            answer: "Yes, Gautam Solar's Mono PERC and TOPCon panels are widely used in residential and commercial rooftop installations, offering high efficiency, PID resistance, and durable performance suited to varying roof sizes and orientations."
        },
        {
            question: "Does Gautam Solar supply modules for large solar power plants?",
            answer: "Yes, Gautam Solar supplies high-capacity bifacial TOPCon and Mono PERC modules for utility-scale and ground-mounted solar power plants, with performance features optimized for large-scale, high-albedo installations."
        },
        {
            question: "How does Gautam Solar ensure quality and detect panel defects?",
            answer: "Gautam Solar ensures quality through 30+ in-line quality checks across fully automated manufacturing processes. Each module undergoes Electroluminescence (EL) testing to detect microcracks, IV (flash) testing to verify power output, insulation and safety tests, and mechanical load validation. Climate chamber testing further ensures durability under extreme conditions."
        },
        {
            question: "What is the expected degradation rate of Gautam Solar TOPCon panels?",
            answer: "Gautam Solar's N-Type TOPCon modules degrade by only 1% in the first year and 0.4% year-on-year afterward, retaining up to 87.4% of rated power after 30 years — compared to standard P-type modules that typically degrade to around 84.8% over 25 years."
        },
        {
            question: "What should you consider when choosing a solar power plant?",
            answer: "Key factors include module efficiency and degradation rate, ALMM/BIS certification, manufacturer track record and warranty support, site-specific conditions like temperature and albedo, and total cost of ownership including BOS savings."
        },
        {
            question: "How are some solar panels more reliable than others?",
            answer: "Reliability comes down to cell technology, manufacturing quality control, resistance to PID and micro-cracking, temperature coefficient, and independent certification — panels built with half-cut cells and NDC (Non-Destructive Cutting) processes typically show fewer field failures over time."
        },

        {
            question: "TOPCon vs Mono PERC — which solar panel technology is better?",
            answer: "TOPCon (Tunnel Oxide Passivated Contact) panels generally offer higher efficiency (up to 22-23%) and lower degradation (1% year-1, 0.4% annually after) compared to Mono PERC panels (efficiency around 20-21%, higher long-term degradation). Mono PERC remains a proven, cost-effective choice for budget-conscious rooftop and utility projects, while TOPCon suits buyers prioritizing maximum long-term energy yield and lower degradation over a 25-30 year lifespan. [VERIFY: exact efficiency ranges against your current datasheets before publishing]"
        },
        {
            question: "What warranty does Gautam Solar offer on its solar panels?",
            answer: "Gautam Solar offers a 12-year product warranty and a 30-year linear performance warranty on TOPCon modules, and a 12-year product warranty with 25-year performance warranty on Mono PERC modules."
        },

        {
            question: "Is Gautam Solar a good brand to buy solar panels from in India?",
            answer: "Gautam Solar is an ALMM and BIS-certified Indian manufacturer with 29+ years of experience, 5 GW of module manufacturing capacity across Haryana and Uttarakhand, and independent recognition among India's Top 10 solar module manufacturers by JMK Research & Analytics and CRISIL's Bridge to India. The company offers both TOPCon and Mono PERC technology for residential, commercial, and utility-scale projects."
        },

    ];

    const faqSchema = {
        "@context": "https://schema.org",
        "@type": 'FAQPage',
        "mainEntity": faq.map(item => ({
            "@type": "Question",
            "name": item.question,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": item.answer
            }
        }))
    };

    return (
        <div className="container py-5">
            <div className='border rounded' style={{ background: '#E5E7EB' }}>
                <Helmet>
                    <script type='application/ld+json'>
                        {JSON.stringify(faqSchema)}
                    </script>
                </Helmet>

                <h2 className="fw-semibold text-center textRes" style={{ color: '#a20000' }}> <span className='text-black'>FREQUENTLY</span> ASKED QUESTIONS</h2>
                <div className="container py-5 d-flex flex-column flex-md-row">

                    <div className="col-md-12"  >
                        <Accordion  >
                            {faq.map((item, index) => (
                                <Accordion.Item eventKey={index} key={index} className="custom-accordion-item">
                                    <Accordion.Header >{index + 1}. {item.question}</Accordion.Header>
                                    <Accordion.Body >
                                        {item.answer}
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQ;
